import { clearAccountHeader, setAccountHeader, setBusinessContext } from '@/http/axios';
import { PATH_DASHBOARD } from '@/routes/paths';

// Conta e negócio gravados juntos antes de uma recarga só. Trocar um de cada vez
// recarregaria duas vezes, e a primeira carga sairia com a conta nova e o negócio
// da conta anterior. A recarga vai para o Dashboard e não para a URL atual, porque
// a tela aberta pode não existir na outra conta.
export const switchAccountAndBusiness = ({
  account,
  businessId,
  to = PATH_DASHBOARD.general.home,
}) => {
  if (account.isOwn) {
    clearAccountHeader();
  } else {
    setAccountHeader(account.ownerId);
  }

  setBusinessContext(businessId);
  window.location.assign(to);
};

// O Meu perfil é sempre o da conta de quem está logado (CBK-681, decisão da daily de 03/11):
// dentro de conta compartilhada ele mostraria e alteraria o cadastro do titular, o que a
// CKTPL-1726 fechou. Então a pessoa volta para a própria conta, no negócio padrão, e o perfil
// abre ali.
export const switchToOwnProfile = (accounts) => {
  const own = (accounts ?? []).find((account) => account.isOwn);

  if (!own) {
    clearAccountHeader();
    window.location.assign(PATH_DASHBOARD.user.profile);
    return;
  }

  const business = own.businesses.find((item) => item.isDefault) ?? own.businesses[0];

  switchAccountAndBusiness({
    account: own,
    businessId: business?.id,
    to: PATH_DASHBOARD.user.profile,
  });
};
